import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import '../styles/blogdetails.css'; 

const blogContent = {
  "how-to-register-and-verify-your-account-on-the-Mahadev-app": {
    title: "How to Register and Verify Your Account on the Mahadev App",
    date: "2025-04-09",
    author: "Vikash Roy",
    views: 5731,
    imageUrl: '/blog1.webp',
    content: `
      <h3>How to Register and Verify Your Account on the Mahadev App</h3>
      <p>
        If you are someone who loves to bet online on sports and other games and 
        you are looking for the right platform to do so, then you have landed at 
        the right page. Mahadev offers you a safe and secure platform to place 
        your bets on various sporting events in a seamless and totally legal manner.
      </p>
      <p>
        But before you place your bets and get ready to make big winnings, you need 
        to create an account on the Mahadev app and then verify it as well. There 
        is more than one way to do that. Given below are the various ways through 
        which you register yourself on the Mahadev app and also verify it for more 
        secure transactions.
      </p>
      <h3>About Mahadev Book</h3>
      <p>
        Since its inception in the year 2010, Mahadev Book has quickly emerged as 
        the best online betting website for live cricket betting. Mahadev is a 
        feature-rich yet secure website equipped with the latest technology. Despite 
        being technically very robust, the website is very user-friendly and easy to 
        navigate even for new players. In addition to the website, Mahadev is also 
        available on the mobile apps in both Android and iOS versions.
      </p>
      <p>
        At Mahadev, the satisfaction of our customers is our top priority. That’s why 
        we bring the latest in sports betting and exclusive content for our users. No wonder, 
        as of today, Mahadev has over 10 lakh loyal customers who bet online on various 
        sports events. We have over 200 offline offices from where we serve our customers 
        and resolve all their needs and queries.
      </p>
      <h3>Step-by-Step Guide to Register on Mahadev</h3>
      <ol>
        <li>
          <strong>Visit the Mahadev Official Website:</strong>
          To create an account on the website, you need to visit the Mahadev official website – 
          <a href="/">http://mahadevbookofficial.social</a>.
        </li>
        <li>
          <strong>Sign Up on the Mahadev Website:</strong>
          Once you are on the website, click on the ‘Sign Up’ button, which is located on the 
          top right corner of the page. You will be directed to the registration page.
        </li>
        <li>
          <strong>Provide Your Details:</strong>
          On the registration page, enter the following details:
          <ul>
            <li>Full Name</li>
            <li>Email Address</li>
            <li>Mobile Number</li>
            <li>Date of Birth (DOB)</li>
          </ul>
          <p>Note: DOB is important to confirm that you are of legal age to bet online. Ensure 
          all details are correct to avoid verification issues later.</p>
        </li>
        <li>
          <strong>Complete the Sign-Up Formalities:</strong>
          <ul>
            <li>Create a strong password using a mix of letters, numbers, and special characters (minimum 6 characters).</li>
            <li>Enter any referral code (if available).</li>
            <li>Accept the terms and conditions after reading them carefully. These outline your rights, duties, and the rules governing the platform.</li>
          </ul>
        </li>
        <li>
          <strong>Verify Your Account:</strong>
          Before you start betting and accessing exclusive content, account verification is mandatory:
          <ul>
            <li>Click on the Submit button.</li>
            <li>You will receive a one-time password (OTP) on your registered email or mobile number.</li>
            <li>Enter the OTP to confirm your account. If you don’t receive it, check your spam folder or request a new OTP.</li>
          </ul>
          <p>For further verification, Mahadev's customer support team may call you on your registered mobile number 
          to confirm details. Once this is completed, your account will be verified.</p>
        </li>
      </ol>
      <h3>Responsible Betting at Mahadev</h3>
      <p>
        At Mahadev, we encourage responsible gaming. We respect your privacy and request you to do the same for others. 
        Follow these guidelines to enjoy betting safely:
      </p>
      <ul>
        <li><strong>Set Your Limits:</strong> Decide a budget and stick to it.</li>
        <li><strong>Bet Responsibly:</strong> Don’t chase losses or bet beyond your means.</li>
        <li><strong>Enjoy the Experience:</strong> Treat betting as entertainment, not a source of income.</li>
      </ul>
      <p>
        Registering and verifying your account on the Mahadev App is a simple and straightforward process. By 
        following the steps outlined above, you can start betting online in a safe, secure, and legal manner. 
        Mahadev’s feature-rich platform, combined with its commitment to customer satisfaction, ensures a seamless 
        betting experience for all users.
      </p>
      <div class="related-link">
      <p><strong>Related Link:</strong>
        <a href="/blogs/reddy-anna-app-features-benefits-and-installation-guide">
          Mahadev App: Features, Benefits, and Installation Guide
        </a>
        </p>
      </div>
    `,
  },
  "mahadev-app-features-benefits-and-installation-guide": {
    title: "Mahadev App: Features, Benefits, and Installation Guide",
    date: "2025-04-09",
    author: "Vikash Roy",
    views: 5391,
    imageUrl: '/blog2.webp',
    content: `
           <h2>Mahadev App: Features, Benefits, and Installation Guide</h2>
      <p>
        Are you in the mood for online gaming and entertainment and looking for the right platform? It's time you visit 
        Mahadev—a leading name in the online gaming and entertainment industry. Mahadev offers exclusive content 
        and services through its website and mobile apps.
      </p>
      <p>
        Mahadev offers a bouquet of sports, entertainment, and community-related activities for a diverse set of customers. 
        The platform is very popular among the betting community and has a large base of loyal players who use Mahadev services 
        for entertainment within the legal framework.
      </p>
      <p>
        If you are new to the online betting industry and looking for reliable and user-friendly betting services, Mahadev is the 
        place to be. This blog will provide you with complete information on the features, benefits, and installation process of this 
        betting platform.
      </p>
      <h3>Features of Mahadev</h3>
      <ul>
        <li>
          <strong>Complete Transparency:</strong> At Mahadev, fairness is a priority. The platform operates with complete 
          transparency, ensuring trust and confidence for all users.
        </li>
        <li>
          <strong>Easy Navigation:</strong> Designed by experts with the user in mind, the platform is extremely easy to navigate. 
          Even first-time users can move across sections effortlessly without needing assistance.
        </li>
        <li>
          <strong>User-Friendly Interface:</strong> Apart from easy navigation, the seamless and intuitive interface makes it simple 
          to access various sections, tools, and features. Finding information is quick and effortless.
        </li>
        <li>
          <strong>Secure Login Process:</strong> Mahadev uses state-of-the-art technology to ensure secure login processes. 
          Advanced encryption systems and privacy policies ensure your financial data and transactions are safe.
        </li>
        <li>
          <strong>Regular Updates:</strong> The platform keeps users updated with odds, probabilities, and the latest trends in sports 
          and entertainment. Notifications ensure that you are always informed and in control.
        </li>
        <li>
          <strong>Exclusive Content:</strong> Mahadev offers exclusive features and content that you won’t find elsewhere, 
          ensuring that users are always a step ahead of the competition.
        </li>
      </ul>
      <h3>How to Install the Mahadev App</h3>
      <ol>
        <li><strong>Visit the Official Platform:</strong> Go to the Google Play Store for Android or the Apple Store for iOS devices. Alternatively, 
        visit the official Mahadev website.</li>
        <li><strong>Go to the Booking Section:</strong> Navigate to the 'booking' section and click on the 'book' option.</li>
        <li><strong>Select Your Preferred Event:</strong> Choose your preferred sports event or service and select a convenient time slot.</li>
        <li><strong>Enter Your Details:</strong> Follow the on-screen instructions and fill in your personal details to confirm your booking.</li>
        <li><strong>Review Your Options:</strong> Double-check your options before making the final submission.</li>
        <li><strong>Confirm and Enjoy:</strong> Once confirmed, you are all set to enjoy the features and services of Mahadev.</li>
      </ol>
      <h3>How to Create a Mahadev ID</h3>
      <ol>
        <li><strong>Visit the Registration Page:</strong> Go to the Mahadev website or app and access the registration section.</li>
        <li><strong>Enter Required Details:</strong> Fill in the necessary information, including your name, email, mobile number, and other required fields.</li>
        <li><strong>Set a Strong Password:</strong> Choose a strong password with a mix of letters, numbers, and special characters.</li>
        <li><strong>Enable Two-Factor Authentication (2FA):</strong> For added security, enable 2FA to minimize the risk of unauthorized access.</li>
      </ol>
      <p><strong>Important Security Tips:</strong></p>
      <ul>
        <li>Never share your login credentials with anyone.</li>
        <li>Update your password regularly.</li>
        <li>Enable all security features provided by the platform.</li>
      </ul>
      <p>
        Once your Mahadev ID is created, log in using your credentials and start enjoying the platform's content and services.
      </p>
      <h3>Using the Mahadev Platform via WhatsApp</h3>
      <ol>
        <li><strong>Save the Official WhatsApp Number:</strong> Add Mahadev's official WhatsApp number to your contacts.</li>
        <li><strong>Send a 'Hi' Message:</strong> Initiate a conversation by sending a 'Hi' message to the saved number.</li>
        <li><strong>Quick Responses and Solutions:</strong> The Mahadev support team will provide real-time responses to queries and quick solutions.</li>
        <li><strong>Join the WhatsApp Community:</strong> By signing up with the Mahadev WhatsApp community, you will receive updates on announcements and exclusive offers directly on your smartphone.</li>
      </ol>
      <h3>Conclusion</h3>
      <p>
        The Mahadev App offers a user-friendly and secure platform for online gaming and betting. With features like easy navigation, 
        secure login processes, regular updates, and exclusive content, it ensures a seamless and enjoyable experience for its users. 
        By following the steps mentioned above, you can easily install the app, create your Mahadev ID, and explore all the exciting features.
      </p>
      <p>
        Whether you are new to the betting industry or an experienced user, Mahadev provides everything you need for a smooth and secure 
        betting journey. Don’t forget to leverage the WhatsApp platform for added convenience and real-time support.
      </p>
    `,
  },
};

const BlogDetails = () => {
  const { title } = useParams();
  const blog = blogContent[title];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (!blog) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        <h1>Blog Not Found</h1>
        <p>The blog you're looking for does not exist.</p>
        <Link to="/blogs" className="back-to-blogs">Back to Blogs</Link>
      </div>
    );
  }

  return (
    <div className="blog-details-container">
      
      <a href="/blogs" className="back-to-blogs">
      &#x25C1;&nbsp;Back to Blog
    </a>
    <h1 className="blog-details-title">{blog.title}</h1>
    <p className="blog-details-meta">
      Published on {blog.date} - By {blog.author}
    </p>
    <p className="blog-details-meta">
      Views: {blog.views}
    </p>
    <img src={blog.imageUrl} alt={blog.title} className="blog-details-image" />
    <div
      className="blog-details-content"
      dangerouslySetInnerHTML={{ __html: blog.content }}
    />
  </div>
  );
};

export default BlogDetails;
